import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import {
  getRightMenuCardSubAPI,
  postRightMenuCardSubAPI
} from '../../../services/right-menu'
import SwalCustom from '../../../alert/swal-custom'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import { ALLMENU, TXTSUCCESS } from '../../../Constants'
import { getRighMenuProfiletOrgAPI } from '../../../services/right-org'
import { updateAllMenu } from '../../../actions/allMenu.action'
import { useDispatch } from 'react-redux'

function SubcardRight({ openSubCard5, roleId, menuId, menuSubid, cardId }) {
  const [reSubCard, setReSubCard] = useState([])
  const [subCard, setSubCard] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    setReSubCard(subCard)
  }, [subCard])

  useEffect(() => {
    const getRightMenuCardSub = async () => {
      const param = { roleId, menuId, menuSubId: menuSubid, cardId }
      const res = await getRightMenuCardSubAPI(param)
      if (!res) return
      if (res.status) {
        setSubCard(res.result)
      }
    }
    if (cardId) {
      getRightMenuCardSub()
    }
  }, [cardId])

  const handleSubCardCheck = (id, check, i) => {
    setSubCard((prev) => {
      return prev.map((d) => (d.card_sub_id === id ? { ...d, ...check } : d))
    })
  }

  const getRighMenuProfiletOrg = async () => {
    const res = await getRighMenuProfiletOrgAPI()
    if (!res) return
    if (res.status) {
      localStorage.setItem(ALLMENU, JSON.stringify(res.result))
      localStorage.setItem(ALLMENU, JSON.stringify(res.result))
      dispatch(updateAllMenu(res.result))
      // dispatch({ type: 'SET_ALLMENU', payload: res.result ?? allMenus ?? [] });
    }
  }


  const onSubmit = async () => {
    try {
      const selectedCards = subCard.filter((c) => c.checked)
      setReSubCard(selectedCards)
      const body = {
        roleId,
        menuId,
        menuSubId: menuSubid,
        cardId,
        cardSubList: reSubCard.map((d, i) => {
          return {
            cardSubId: d.card_sub_id,
            checked: d.checked ? 1 : 0
          }
        })
      }
      SwalCustom({
        title: 'Are you sure?',
        text: 'Do you want to confirm?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!'
      }).then((result) => {
        if (result.isConfirmed) {
          postRightMenuCardSub(body)
        }
      })
    } catch (error) {
      Error_500(error)
    }
  }

  const postRightMenuCardSub = async (body) => {
    const resp = await postRightMenuCardSubAPI(body)
    if (resp && resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      })
      getRighMenuProfiletOrg()
    } else {
      Error_false(resp)
    }
  }


  return (
    <span className="col-4">
      {openSubCard5 ? (
        <>
          <span className="">
            {subCard.map((sub, i) => (
              <div className="pt-2 pb-2 p-5 button-box" key={i}>
                <span className="d-flex gap-2 m-4 mt-0 mb-0">
                  <Form.Check
                    type="checkbox"
                    checked={sub.checked}
                    onClick={() =>
                      handleSubCardCheck(
                        sub?.card_sub_id,
                        {
                          checked: !sub?.checked
                        },
                        i
                      )
                    }
                  />
                  {sub?.card_sub_name}
                </span>
              </div>
            ))}
          </span>
          <span className="d-flex justify-content-center ">
            <div className="position-absolute bottom-0">
              {subCard[0] ? (
                <Button
                  onClick={onSubmit}
                  style={{ minWidth: '150px', marginBottom: '100px' }}
                >
                  Add
                </Button>
              ) : (
                <></>
              )}
            </div>
          </span>
        </>
      ) : (
        <></>
      )}
    </span>
  )
}

export default SubcardRight
